export default "__VITE_ASSET__Dw4Lc0Lo__"